module.exports = __webpack_public_path__ + "img/search.d17b553f.svg";